module.exports = {
  COMPONENT_TYPES: {
    radioGroup: 'radioGroup',
    switch: 'switch',
  },
  FILTERS_IDS: {
    CATEGORY: 'category',
    INSTALLMENTS: 'installments',
    PRICE: 'price',
    PROMOTION_TYPE: 'promotion_type',
    DOMAIN: 'domain_id',
    DEAL: 'deal_ids',
    CONTAINER: 'container_id',
    SHIPPING_COST: 'shipping_cost',
    SHIPPING_TIME: 'shipping_time',
    SHIPPING: 'shipping',
  },
  FILTERS_ORIGINS: {
    SELECTOR: 'scut',
    QCAT: 'qcat',
  },
  QUERY_PARAMS_VALIDATORS: {
    category: /^(?=.{0,20}$)(MLA|MLB|MLM|MLU|MPE|MCO|MLC|MLV|MEC)\d+$/,
    installments: /^(yes)?$/,
    price: /^([*|\d]+(?:USD)?|\d+(?:\.\d+)?)-([*|\d]+(?:USD)?|\d+(?:\.\d+)?|\*)$/,
    promotion_type: /^(deal_of_the_day|lightning)?$/,
    domain_id: /^(MLA|MLB|MLM|MLU|MPE|MCO|MLC|MLV|MEC)-[A-Z_]+(\$?(MLA|MLB|MLM|MLU|MPE|MCO|MLC|MLV|MEC)-[A-Z_]+)*$/,
    deal_ids: /^(?=.{0,20}$)(MLA|MLB|MLM|MLU|MPE|MCO|MLC|MLV|MEC)\d+$/,
    container_id: /^(?=.{0,20}$)(MLA|MLB|MLM|MLU|MPE|MCO|MLC|MLV|MEC)\d+(?:-\d+)$/,
    shipping_cost: /^(free)?$/,
    shipping_time: /^(sameday)?$/,
    shipping: /^(fulfillment)?$/,
    limit: /^\d+$/,
    offset: /^\d+$/,
    page: /^\d+$/,
    dealPrintId: /.*/,
    adserver_scope: /.*/,
  },
};
